import variables from '../variables';

const MuiPickersDay = {
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        color: variables.colors.midGrey3,
      },
      '&.Mui-selected': {
        color: variables.colors.white,
      },
    },
  },
};

export default MuiPickersDay;
